import React from 'react';
import './Updater.css';
import axios from 'axios';

function Updater(){

    const [didSave, setDidSave] = React.useState(false);
    const [saveFailure, setSaveFailure] = React.useState(false);

    const [theJson, setTheJson] = React.useState([]);
    const [creator, setCreator] = React.useState(
        {
            "isOpen": false,
            "noView": false,
            "name": "",
            "lat": 0,
            "lng": -0,
            "color": "red",
            "amenities":[
            ]
        }
    );

    const checkboxes = ['dock','cabanas','dogs','playground','bathrooms','sports','swimming','wheelchair_access','vendors']

     // Load in marker list from DB upon load
    React.useEffect(() => {
        axios.get('/plc_map/getPlcMarkers')
        .then(response =>{
            setTheJson(response.data[0].content)
            // setMarkers(response.data.fields)
        })
        .catch(err =>{
            console.log("Unable to retrieve marker data.", err)
        })
    }, [])

    const handleSaveClick = () => {
        axios.post('/plc_map/updatePlcMarkers', theJson)
        .then(response =>{
            // console.log('response', response)
            // setMarkers(response.data.fields)\
            setDidSave(true)
            setTimeout(() => {
                setDidSave(false) 
            }, 4000)
        })
        .catch(err =>{
            console.log("Unable to retrieve marker data.", err)
            setSaveFailure(true)
            setTimeout(() => {
                setSaveFailure(false) 
            }, 4000)
        })
    }

    const handleChange = (event, field, index) => {

        let editable = JSON.parse(JSON.stringify(theJson));

        if(checkboxes.includes(field)){
            if(event.target.checked){
                editable[index].amenities.push(field)
            }
            else{
                editable[index].amenities.splice(editable[index].amenities.findIndex((element) => element === field), 1);
            }
        }
        else if(field === "red" || field === "blue"){
            editable[index].color = field;
        }
        else if(field === "lat" || field === "lng"){
            console.log("lats n longs", event.target.value)
            editable[index][field] = Number(event.target.value);
        }
        else if(field === "name"){
            editable[index].name = event.target.value;
        }
        else if(field === 'noView'){
            editable[index].noView = event.target.checked;
        }

        setTheJson(editable)

    }

    const handleCreation = () => {

        let editable = JSON.parse(JSON.stringify(theJson));

        // if Name is blank, f u
        if(creator.name.length === 0 || !creator.name || !creator.lat || !creator.lng){
            window.alert('Required fields are missing, please try again.')
        }
        else{
            editable.push(creator)
            
            axios.post('/plc_map/updatePlcMarkers', editable)
            .then(response =>{
                window.alert('It has been added successfully.')
                setTheJson(editable)
                setCreator(
                    {
                        "isOpen": false,
                        "noView": false,
                        "name": "",
                        "lat": 0,
                        "lng": -0,
                        "color": "red",
                        "amenities":[
                        ]
                    }
                )
            })
            .catch(err =>{
                console.log("Unable to add record", err)
            })
        }
    }

    const handleChangeCreator = (event, field) => {

        let editable = JSON.parse(JSON.stringify(creator));

        if(checkboxes.includes(field)){
            if(event.target.checked){
                editable.amenities.push(field)
            }
            else{
                if(editable.amenities.findIndex((element) => element === field) > -1){
                    editable.amenities.splice(editable.amenities.findIndex((element) => element === field), 1);
                }
            }
        }
        else if(field === "red" || field === "blue"){
            editable.color = field;
        }
        else if(field === "lat" || field === "lng"){
            editable[field] = Number(event.target.value);
        }
        else if(field === "name"){
            editable.name = event.target.value;
        }
        else if(field === 'noView'){
            editable.noView = event.target.checked;
        }

        setCreator(editable)

    }

    const handleDeleteClick = async (index) =>{
        if(window.confirm('Are you sure you want to remove this marker?')){
            let editable = JSON.parse(JSON.stringify(theJson));
            editable.splice(index, 1)
            

            axios.post('/plc_map/updatePlcMarkers', editable)
            .then(response =>{
                // console.log('response', response)
                // setMarkers(response.data.fields)\
                window.alert('It has been successfully deleted.')
                setTheJson(editable)
            })
            .catch(err =>{
                console.log("Unable to delete record", err)

            })
        }
    }


    return (
        <div style={{
            display: 'flex', 
            flexDirection:'row',
            height: '100vh'
        }}>
            <div 
                style={{ 
                    width: '50%',
                    overflowY: 'scroll'
                }}
            >
            {
                theJson.map(function(item, index){
                    return (
                        <div 
                            style={{
                                marginBottom: '10px',
                                marginLeft: '10px',
                                border: '2px solid black',
                                padding: '5px',
                                backgroundColor: 'lightgray',
                            }}
                        >
                            <div className='aboveAndBelow'>
                                <label className="labeler" >Name</label>
                                <input value={item.name}
                                    onChange={(event) => handleChange(event, 'name', index)}
                                ></input>
                            </div>

                            <div className='aboveAndBelow'>
                                <label className="labeler">Latitude</label>
                                <input value={item.lat} type="number" step="0.0001"
                                    onChange={(event) => handleChange(event, 'lat', index)}
                                ></input>
                            </div>

                            <div className='aboveAndBelow'>
                                <label className="labeler">Longitude</label>
                                <input value={item.lng} type="number" step="0.0001"
                                    onChange={(event) => handleChange(event, 'lng', index)}
                                ></input>
                            </div>
                            
                            <div className='aboveAndBelow'>
                                <label className="labeler">Type</label>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Shoreline Access</label>
                                    <input type="radio" value="red" checked={item.color==="red"}
                                        onChange={(event) => handleChange(event, 'red', index)}
                                    ></input>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Public Beach Access</label>
                                    <input type="radio" value="blue" checked={item.color==="blue"}
                                        onChange={(event) => handleChange(event, 'blue', index)}
                                    ></input>
                                </div>


                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label className="labeler">Hide Street View?</label>
                                    <input type='checkbox' value={'noView'} checked={item.noView}
                                        onChange={(event) => handleChange(event, 'noView', index)}
                                    ></input>
                                </div>

                            </div>

                            <label className="labeler">Amenities</label>
                            <div className='aboveAndBelow' style={{border: '1px solid black', margin: '4px', padding: '5px'}}>
                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Boat Ramp / Dock</label>
                                    <input type='checkbox' value={'dock'} checked={item.amenities.includes('dock')}
                                        onChange={(event) => handleChange(event, 'dock', index)}
                                    ></input>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Cabanas/Benches</label>
                                    <input type='checkbox' value={'cabanas'} checked={item.amenities.includes('cabanas')}
                                        onChange={(event) => handleChange(event, 'cabanas', index)}
                                    ></input>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Dogs Allowed</label>
                                    <input type='checkbox' value={'dogs'} checked={item.amenities.includes('dogs')}
                                        onChange={(event) => handleChange(event, 'dogs', index)}
                                    ></input>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Playground</label>
                                    <input type='checkbox' value={'playground'} checked={item.amenities.includes('playground')}
                                        onChange={(event) => handleChange(event, 'playground', index)}
                                    ></input>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Restrooms</label>
                                    <input type='checkbox' style={{marginLeft:'10px'}} value={'bathrooms'} checked={item.amenities.includes('bathrooms')}
                                        onChange={(event) => handleChange(event, 'bathrooms', index)}
                                    ></input>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Sports</label>
                                    <input type='checkbox' value={'sports'} checked={item.amenities.includes('sports')}
                                        onChange={(event) => handleChange(event, 'sports', index)}
                                    ></input>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Swimming</label>
                                    <input type='checkbox' value={'swimming'} checked={item.amenities.includes('swimming')}
                                        onChange={(event) => handleChange(event, 'swimming', index)}
                                    ></input>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Wheelchair Access</label>
                                    <input type='checkbox' value={'wheelchair_access'} checked={item.amenities.includes('wheelchair_access')}
                                        onChange={(event) => handleChange(event, 'wheelchair_access', index)}
                                    ></input>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label>Vendors</label>
                                    <input type='checkbox' value={'vendors'} checked={item.amenities.includes('vendors')}
                                        onChange={(event) => handleChange(event, 'vendors', index)}
                                    ></input>
                                </div>
                                
                            </div>

                            <button
                                style={{
                                    color:'white',
                                    backgroundColor: 'red',
                                    marginLeft:'90%'
                                }}
                                onClick={()=>handleDeleteClick(index)}
                            >
                                Delete
                            </button>

                        </div>
                    )
                })
            }
            </div>
            <div style={{ 
                width: '50%',
                paddingLeft: '20px',
                height: '100vh',
                overflowY: 'scroll'
            }}>

                <h3 style={{marginLeft: '20px'}}>To add a new marker, fill out the form below and click the "Insert" button</h3>

                <div 
                    style={{ 
                        width: '50%',
                        marginLeft: '10px'
                    }}
                >
                    <div 
                        style={{
                            marginBottom: '10px',
                            marginLeft: '10px',
                            border: '2px solid black',
                            padding: '5px',
                            backgroundColor: 'lightgray',
                        }}
                    >
                        <div className='aboveAndBelow'>
                            <label className="labeler" >Name</label>
                            <input value={creator.name}
                                onChange={(event) => handleChangeCreator(event, 'name')}
                            ></input>
                        </div>

                        <div className='aboveAndBelow'>
                            <label className="labeler">Latitude</label>
                            <input value={creator.lat} type="number" step="0.0001"
                                onChange={(event) => handleChangeCreator(event, 'lat')}
                            ></input>
                        </div>

                        <div className='aboveAndBelow'>
                            <label className="labeler">Longitude</label>
                            <input value={creator.lng} type="number" step="0.0001"
                                onChange={(event) => handleChangeCreator(event, 'lng')}
                            ></input>
                        </div>
                        
                        <div className='aboveAndBelow'>
                            <label className="labeler">Type</label>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Shoreline Access</label>
                                <input type="radio" value="red" checked={creator.color==="red"}
                                    onChange={(event) => handleChangeCreator(event, 'red')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Public Beach Access</label>
                                <input type="radio" value="blue" checked={creator.color==="blue"}
                                    onChange={(event) => handleChangeCreator(event, 'blue')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <label className="labeler">Hide Street View?</label>
                                    <input type='checkbox' value={'noView'} checked={creator.noView}
                                        onChange={(event) => handleChangeCreator(event, 'noView')}
                                    ></input>
                            </div>

                        </div>

                        <label className="labeler">Amenities</label>
                        <div className='aboveAndBelow' style={{border: '1px solid black', margin: '4px', padding: '5px'}}>
                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Boat Ramp / Dock</label>
                                <input type='checkbox' value={'dock'} checked={creator.amenities.includes('dock')}
                                    onChange={(event) => handleChangeCreator(event, 'dock')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Cabanas/Benches</label>
                                <input type='checkbox' value={'cabanas'} checked={creator.amenities.includes('cabanas')}
                                    onChange={(event) => handleChangeCreator(event, 'cabanas')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Dogs Allowed</label>
                                <input type='checkbox' value={'dogs'} checked={creator.amenities.includes('dogs')}
                                    onChange={(event) => handleChangeCreator(event, 'dogs')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Playground</label>
                                <input type='checkbox' value={'playground'} checked={creator.amenities.includes('playground')}
                                    onChange={(event) => handleChangeCreator(event, 'playground')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Restrooms</label>
                                <input type='checkbox' style={{marginLeft:'10px'}} value={'bathrooms'} checked={creator.amenities.includes('bathrooms')}
                                    onChange={(event) => handleChangeCreator(event, 'bathrooms')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Sports</label>
                                <input type='checkbox' value={'sports'} checked={creator.amenities.includes('sports')}
                                    onChange={(event) => handleChangeCreator(event, 'sports')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Swimming</label>
                                <input type='checkbox' value={'swimming'} checked={creator.amenities.includes('swimming')}
                                    onChange={(event) => handleChangeCreator(event, 'swimming')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Wheelchair Access</label>
                                <input type='checkbox' value={'wheelchair_access'} checked={creator.amenities.includes('wheelchair_access')}
                                    onChange={(event) => handleChangeCreator(event, 'wheelchair_access')}
                                ></input>
                            </div>

                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <label>Vendors</label>
                                <input type='checkbox' value={'vendors'} checked={creator.amenities.includes('vendors')}
                                    onChange={(event) => handleChangeCreator(event, 'vendors')}
                                ></input>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <button 
                    style={{
                        width: '170px',
                        height: '35px',
                        backgroundColor: 'lightgreen',
                        fontSize: '24px',
                        marginTop: '20px',
                        marginLeft: '20px',
                        marginBottom: '20px',
                        cursor: 'pointer'
                    }}
                    onClick={() => handleCreation()}
                >
                    {'<< Insert'}
                </button>


                <h3 style={{marginLeft: '20px'}}>To save your changes, click the "Save" button below</h3>

                <button 
                    style={{
                        width: '170px',
                        height: '35px',
                        backgroundColor: 'lightgreen',
                        fontSize: '24px',
                        marginTop: '20px',
                        marginLeft: '20px',
                        marginBottom: '20px',
                        cursor: 'pointer'
                    }}
                    onClick={() => handleSaveClick()}
                >
                    Save
                </button>

                <h4 hidden={!didSave}
                    style={{
                        color: 'green',
                        marginLeft: '20px'
                    }}
                >Saved!</h4>
                <h5 hidden={!saveFailure}
                    style={{
                        color: 'red',
                        marginLeft: '20px'
                    }}
                >Problem Saving</h5>

            </div>
        </div>
    )

}

export default Updater;